import { createContext, ReactElement, useState } from 'react';
import OverlayView from '../components/OverlayView';

export type OverlayViewProps = {
  viewContent: ReactElement | undefined
  setViewContent: (reactElement: ReactElement | undefined) => void;
}

export const OverlayContext = createContext<OverlayViewProps>(
  { viewContent: undefined, setViewContent: () => 0 },
);

export const OverlayProvider: React.FC = ({ children }) => {
  const [showOverlayViewContext, setShowOverlayViewContext] = useState<ReactElement | undefined>(
    undefined,
  );
  return (
    <OverlayContext.Provider value={
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      {
        viewContent: showOverlayViewContext,
        setViewContent: setShowOverlayViewContext,
      }
}
    >
      <OverlayView>
        {children}
      </OverlayView>
    </OverlayContext.Provider>
  );
};
